import React, { useEffect, useState } from 'react';
import { Star, CheckCircle, ChevronLeft, ChevronRight } from 'lucide-react';
const reviews = [{
  text: '¡Increíble experiencia! Pasamos toda la noche intentando resolver el caso. La cantidad de pistas es impresionante, parece un caso real de verdad.',
  name: 'María González',
  location: 'Madrid',
  avatar: 'https://randomuser.me/api/portraits/women/44.jpg'
}, {
  text: 'Lo hicimos en pareja y fue la mejor noche en mucho tiempo. Muy bien pensado, los documentos se sienten auténticos. ¡Ya pedimos el siguiente!',
  name: 'Carlos Ruiz',
  location: 'Barcelona',
  avatar: 'https://randomuser.me/api/portraits/men/32.jpg'
}, {
  text: 'Perfecto para una noche con amigos. Nos reímos muchísimo y nos pusimos muy intensos resolviendo las pistas. 100% recomendado.',
  name: 'Laura Martínez',
  location: 'Valencia',
  avatar: 'https://randomuser.me/api/portraits/women/68.jpg'
}, {
  text: 'Descarga inmediata, calidad excelente. Los 4 casos son muy diferentes entre sí. Una compra que vale muchísimo la pena.',
  name: 'Andrés López',
  location: 'Sevilla',
  avatar: 'https://randomuser.me/api/portraits/men/75.jpg'
}, {
  text: 'Nunca pensé que un juego digital pudiera ser tan inmersivo. Los documentos, las pistas, todo está muy cuidado. ¡Genial!',
  name: 'Sofía Herrera',
  location: 'Buenos Aires',
  avatar: 'https://randomuser.me/api/portraits/women/21.jpg'
}];
export function FeaturedReview() {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);
  const go = (dir: number) => {
    if (animating) return;
    setAnimating(true);
    setTimeout(() => {
      setCurrent(prev => (prev + dir + reviews.length) % reviews.length);
      setAnimating(false);
    }, 200);
  };
  useEffect(() => {
    const timer = setInterval(() => go(1), 5000);
    return () => clearInterval(timer);
  }, []);
  const review = reviews[current];
  return <section className="py-5 px-4" style={{
    backgroundColor: '#0d0d0d'
  }} data-id="element-99">
      <div className="max-w-xl mx-auto" data-id="element-100">
        <h2 className="text-center text-lg sm:text-xl font-bold text-white mb-5" style={{
        fontFamily: "'Playfair Display', serif"
      }} data-id="element-101">
          Lo que dicen nuestros detectives
        </h2>

        {/* Carousel card */}
        <div className="relative" data-id="element-102">
          <div className="rounded-lg p-5 relative transition-opacity duration-200" style={{
          backgroundColor: '#1a1a1a',
          border: '1px solid #333',
          borderLeft: '4px solid #c0392b',
          opacity: animating ? 0 : 1
        }} data-id="element-103">
            {/* Quote mark */}
            <div className="absolute top-3 right-5 text-5xl font-serif leading-none opacity-10" style={{
            color: '#c0392b'
          }} data-id="element-104">
              "
            </div>

            {/* Stars */}
            <div className="flex gap-1 mb-3" data-id="element-105">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} size={14} fill="#f0c040" stroke="#f0c040" data-id="element-106" />)}
            </div>

            {/* Review text */}
            <p className="text-gray-300 text-sm leading-relaxed mb-4 italic" data-id="element-107">
              "{review.text}"
            </p>

            {/* Author */}
            <div className="flex items-center gap-3" data-id="element-108">
              <img src={review.avatar} alt={review.name} className="w-9 h-9 rounded-full object-cover flex-shrink-0" style={{
              border: '2px solid #c0392b'
            }} data-id="element-109" />
              <div data-id="element-110">
                <p className="text-white font-semibold text-sm" data-id="element-111">
                  {review.name}
                </p>
                <div className="flex items-center gap-2" data-id="element-112">
                  <CheckCircle size={11} style={{
                  color: '#27ae60'
                }} data-id="element-113" />
                  <span className="text-xs" style={{
                  color: '#27ae60'
                }} data-id="element-114">
                    Compra verificada · {review.location}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Nav buttons */}
          <button onClick={() => go(-1)} className="absolute -left-4 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full flex items-center justify-center transition-opacity hover:opacity-80" style={{
          backgroundColor: '#c0392b'
        }} data-id="element-115">
            <ChevronLeft size={16} className="text-white" data-id="element-116" />
          </button>
          <button onClick={() => go(1)} className="absolute -right-4 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full flex items-center justify-center transition-opacity hover:opacity-80" style={{
          backgroundColor: '#c0392b'
        }} data-id="element-117">
            <ChevronRight size={16} className="text-white" data-id="element-118" />
          </button>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-3" data-id="element-119">
          {reviews.map((_, i) => <button key={i} onClick={() => {
          setAnimating(true);
          setTimeout(() => {
            setCurrent(i);
            setAnimating(false);
          }, 200);
        }} className="w-2 h-2 rounded-full transition-all" style={{
          backgroundColor: i === current ? '#c0392b' : '#444'
        }} data-id="element-120" />)}
        </div>

        {/* Mini stats */}
        <div className="grid grid-cols-3 gap-4 mt-4" data-id="element-121">
          {[{
          value: '176+',
          label: 'Detectives satisfechos'
        }, {
          value: '4.9/5',
          label: 'Valoración media'
        }, {
          value: '4',
          label: 'Casos incluidos'
        }].map(stat => <div key={stat.label} className="text-center" data-id="element-122">
              <div className="text-xl font-black" style={{
            color: '#f0c040',
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-123">
                {stat.value}
              </div>
              <div className="text-xs text-gray-500 mt-1" data-id="element-124">{stat.label}</div>
            </div>)}
        </div>
      </div>
    </section>;
}